export default __webpack_public_path__ + "locales/en/DeleteDialog.json?hash=8662567714251815c1a6aba31248c511";